<template >
  <div>
    <el-breadcrumb class="left" separator="/">
      <!-- <el-breadcrumb-item>
        <a>首页</a>
      </el-breadcrumb-item> -->
      <el-breadcrumb-item>
        <a>小程序</a>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <a @click="toList()">{{ title }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="title2">
        <a @click="title2Back()">{{ title2 }}</a></el-breadcrumb-item
      >
      <el-breadcrumb-item v-if="title3">{{ title3 }}</el-breadcrumb-item>
    </el-breadcrumb>

    <el-link :underline="false" class="loginout" @click="loginOut">退出登录</el-link>
  </div>
</template>

<script>
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'

export default {
  props: {
    meun: {
      type: Object
    },
    title: {
      type: String
    },
    title2: {
      type: String
    },
    title3: {
      type: String
    }
  },
  methods: {
    loginOut() {
      Api.loginout()
    },
    toList() {
      if (this.title2 != null) {
        this.$router.push(this.meun.listPath)
      }
    },
    title2Back() {
      if (this.title3 != null) {
        Api.verifyApi(CApi.api_getAisInfoById, verify => {
          if (verify) {
            this.$router.push('/data/user-details')
          }
        })
      }
    }
  }
}
</script>

<style lang="less">
.header_layout {
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-radius: 5px;
}
.header_layout span {
  line-height: 50px;
  margin-right: 15px;
}
.header_layout .left {
  float: left;
}
.header_layout .right {
  float: right;
}
.loginout {
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/layout/headerLayoutWxapp.vue